import { connect } from 'react-redux';
import EditEntity from '../components/EntityEditing/EditEntity';

const mapStateToProps = state => ({
  loadingOverwrites: state.tournamentOverwrites.loading,
  writing: state.tournamentOverwrites.writing,
  overwrites: state.tournamentOverwrites.overwrites,
  writeError: state.tournamentOverwrites.writeError,
  fetchOverwriteError: state.tournamentOverwrites.error,
  currentEdits: state.edits.currentEdits,
  editsDirty: state.edits.dirty,
});

export default connect(mapStateToProps)(EditEntity);
